import React from 'react';
import ApexChart from 'react-apexcharts';
import { chartOptions } from '../dashboardTheme';
import { formatCurrency } from '@utils/utils';

// Ring chart with a big center figure and a legend of value + share per slice.
// centerValue/centerLabel default to the total; pass e.g. "91%" / "Sóng tốt" to override.
const DonutStat = ({
  title,
  items,
  unit = '',
  centerValue,
  centerLabel = 'Tổng',
  onSelect,
  compact = false
}) => {
  const size = compact ? 132 : 150;
  const values = items.map((item) => Number(item.value || 0));
  const total = values.reduce((a, b) => a + b, 0);
  const clickable = typeof onSelect === 'function';
  const pct = (value) => (total ? Math.round((value / total) * 100) : 0);

  const options = chartOptions({
    chart: {
      type: 'donut',
      sparkline: { enabled: true },
      events: clickable
        ? {
            dataPointSelection: (event, chartContext, config) =>
              onSelect(items[config?.dataPointIndex], config?.dataPointIndex)
          }
        : {}
    },
    colors: items.map((item) => item.color),
    labels: items.map((item) => item.label),
    legend: { show: false },
    dataLabels: { enabled: false },
    stroke: { width: 2, colors: ['#ffffff'] },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: { size: '72%', labels: { show: false } }
      }
    },
    states: { hover: { filter: { type: 'none' } } },
    tooltip: {
      y: { formatter: (val) => `${formatCurrency(val, 0)}${unit ? ` ${unit}` : ''}` }
    }
  });

  return (
    <div className={`donut-stat ${compact ? 'is-compact' : ''}`}>
      {title && <div className="donut-stat__title">{title}</div>}
      <div
        className={`donut-stat__chart ${clickable ? 'is-clickable' : ''}`}
        style={{ width: size, height: size }}>
        <ApexChart options={options} series={values} type="donut" height={size} width={size} />
        <div className="donut-stat__center">
          <strong>{centerValue ?? formatCurrency(total, 0)}</strong>
          <span>{centerLabel}</span>
        </div>
      </div>
      <ul className="donut-stat__legend">
        {items.map((item, index) => (
          <li
            key={item.label}
            className={clickable ? 'is-clickable' : ''}
            onClick={clickable ? () => onSelect(item, index) : undefined}>
            <span className="donut-stat__dot" style={{ background: item.color }} />
            <span className="donut-stat__label">{item.label}</span>
            <span className="donut-stat__value" style={{ color: item.color }}>
              {formatCurrency(values[index], 0)} ({pct(values[index])}%)
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DonutStat;
